import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCxllZy0VpA7aHKav9EWq1J9rr-fhRThMg',
  authDomain: 'assist-c12b5.firebaseapp.com',
  databaseURL: 'https://assist-c12b5.firebaseio.com',
  projectId: 'assist-c12b5',
  storageBucket: 'assist-c12b5.appspot.com',
  messagingSenderId: '155162359612',
  appId: '1:155162359612:web:6ffbba868379899a75d039',
  measurementId: 'G-YNQW4QEX5K',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const auth = firebase.auth();
export const db = firebase.firestore();

if (window.location.hostname === 'localhost') {
  // db.settings({
  //   // host: 'localhost:8080',
  //   ssl: false,
  // });
}

export const providers = {
  google: new firebase.auth.GoogleAuthProvider(),
  github: new firebase.auth.GithubAuthProvider(),
};
export default firebase;
